export default __webpack_public_path__ + "static/media/icn_card.c2280bcc.svg";